export default [
  {
    path: 'ingreso',
    name: 'sign-in',
    meta: { layout: 'full-page' },
    component: () => import('@/febos/global/usuario/vistas/Ingreso')
  },
  {
    path: 'no-autorizado',
    name: 'page-error-401',
    meta: { layout: 'full-page' },
    component: () => import('@/views/pages/Error401')
  },
  {
    // Ruta de prueba del PDF Form Builder (Fase 1). Pública, hija del portal.
    // requiereLogin:false explícito para sobrescribir el meta del padre /:portal.
    path: 'form-builder-demo',
    name: 'form-builder-demo',
    meta: { layout: 'full-page', requiereLogin: false },
    component: () => import('@/febos/global/pdf/formBuilder/vistas/FormBuilderDemo.vue')
  },
  {
    // Vista demo del Document Builder sobre el CORE OSS de GrapesJS (BSD-3).
    // Pública, hija del portal. requiereLogin:false explícito sobrescribe el
    // meta del padre /:portal, análoga a form-builder-demo.
    path: 'doc-builder-demo',
    name: 'doc-builder-demo',
    meta: { layout: 'full-page', requiereLogin: false },
    component: () => import('@/febos/global/customDocuments/docBuilder/vistas/DocBuilderDemo.vue')
  }
];
